export enum AudienceType {
    INSIGHTS,
    LOCATION,
    CONSUMERS,
    FRANCHISE
}